import { useEffect, useState } from "react"

import COPY_CONSTANTS from "~config/copy-constants"

// TODO: Move to shared libs since dashboard is using the same hook
export function useNativeShare() {
    const isSupported = useIsNativeShareSupported()
    const [isSharing, setIsSharing] = useState(false)

    async function share(
        data: ShareData,
        onSuccess?: () => void,
        onError?: (error: Error) => void
    ) {
        const canShare = navigator.canShare(data)
        /**
         * If native share is not supported or the data is not sharable
         * show an error message and end execution
         * */
        if (!isSupported || !canShare) {
            onError?.(new Error(COPY_CONSTANTS.SHARE.NATIVE_SHARE_ERROR))
            return
        }

        setIsSharing(true)

        try {
            await navigator.share(data)
            setIsSharing(false)
            onSuccess?.()
        } catch (error) {
            setIsSharing(false)
            if (error instanceof Error) {
                onError?.(error)
            } else {
                onError?.(new Error("Failed to share"))
            }
        }
    }

    return { isSupported, isSharing, share }
}

function useIsNativeShareSupported() {
    const [navigator, setNavigator] = useState<Navigator | null>(null)

    useEffect(() => {
        setNavigator(window.navigator)
    }, [])

    return !!navigator?.share && !!navigator.canShare
}
